<template>
  <v-row md="1">
    <Guide :show="$props.show" title="Apply for Staff Position" @close="$emit('dismiss')">
      <template v-slot:header>
        <v-row>
          <v-col md="4" :align="isMobile ? 'center' : 'start'">
            <v-img aspect-ratio="1" :width="!isMobile ? 300 : 150" :height="!isMobile ? 200 : 100" contain
                   src="/img/ceritificate.svg"/>
          </v-col>

          <v-col cols="12" md="8" sm="12">
            <div class="d-block">
              <v-form ref="form" v-model="isValid" class="d-block">
                <v-text-field 
                  :rules="rules.emailRules" 
                  full-width 
                  color="black" 
                  dense
                  v-model="formData.email" 
                  placeholder="Email Address"
                  type="email"/>

                <v-text-field 
                  :rules="rules.passwordRules" 
                  full-width 
                  color="black"
                  dense 
                  v-model="formData.password" 
                  placeholder="Password"
                  type="password"/>

                <p class="body-2">After registering, sign in to add your personal and application details.</p>

                <div class="mt-5">
                  <v-btn 
                    @click="register" 
                    :disabled="!isValid || loading"
                    :loading="loading"
                    color="primary" 
                    width="100%" 
                    rounded 
                    depressed>
                    Register
                  </v-btn>
                </div>
              </v-form>
            </div>
          </v-col>

          <v-col cols="12" md="8" sm="6" class="mx-auto">
            <div class="d-block text-center text-md-right">
              <p class="" style="font-size: 14px; color: black; line-height: 1.2em;">Already have an account?</p>
              <p style="color: #76BF05; line-height: 0.8em; cursor: pointer;" class="mr-md-10" @click="switchToLogin">
                Sign In
              </p>
            </div>
          </v-col>
        </v-row>
      </template>
    </Guide>
    <loading-dialog :show="loading" />
    <message-box :show="messageShow" :message="message" :type="messageType"
                 v-on:close-message="messageShow = !messageShow" />
  </v-row>
</template>

<script lang="ts">
import Vue from "vue";
import Component from "vue-class-component";
import Guide from "@/components/Guide.vue";
import ValidationRules from "@/utils/ValidationRules";
import { registerApplicantApi, ApplicationRegistrationType } from "@/config/api/application";
import ErrorResolver from "@/utils/ErrorResolver";
import LoadingDialog from "@/components/LoadingDialog.vue";
import MessageBox from "@/components/MessageBox.vue";

@Component({
  components: { MessageBox, LoadingDialog, Guide },
  props: {
    show: Boolean
  }
})
export default class ApplicationRegistration extends Vue {
  public isValid: boolean = false;
  public rules = ValidationRules;
  public loading: boolean = false;
  public message: string = '';
  public messageShow: boolean = false;
  public messageType: string = '';

  public formData: ApplicationRegistrationType = {
    email: '',
    password: ''
  }

  public close() {
    this.$emit('dismiss')
  }

  public switchToLogin() {
    this.$emit('switch-to-login')
  }

  get isMobile() {
    return this.$vuetify.breakpoint.smAndDown;
  }

  public async register() {
    if (!this.isValid) return;
    
    this.loading = true;
    try {
      const response = await registerApplicantApi(this.formData);
      
      this.message = response.data.message || 'Registration successful. Sign in to complete your application.';
      this.messageType = 'success';
      this.messageShow = true;
      
      // Reset form
      this.formData = {
        email: '',
        password: ''
      };
      
      // Close dialog after showing success message
      setTimeout(() => {
        this.switchToLogin();
      }, 2000);
      
    } catch (err) {
      console.log(err);
      ErrorResolver.checkErrors(this, err);
    } finally {
      this.loading = false;
    }
  }

}
</script>

<style scoped>
</style>
